export default __webpack_public_path__ + "static/media/Green-Jeweled-Diffuser-Stretch-Bracelet-with-6-Lava-Beads.8a23cb41.jpg";